import { EnvironmentVariable, getEnvVar } from '@lib/config';
import { failingFetcher } from '@lib/http/fetch';

const SLUGS_TTL_MS = 5 * 60 * 1000;
const EMPTY_SLUGS_TTL_MS = 15 * 1000;

type SlugsEntry = {
  promise: Promise<Record<string, number> | undefined>;
  expiresAt: number;
};

let cached: SlugsEntry | null = null;

// Slugs only change on CMS publish; caching per pod avoids a loopback fetch
// through the public LB on every page view, at the cost of new publishes
// appearing up to SLUGS_TTL_MS late (no invalidation reaches pod memory).
export function getLandingPageSlugs() {
  if (!cached || Date.now() >= cached.expiresAt) {
    const entry: SlugsEntry = {
      promise: failingFetcher(
        `${getEnvVar(EnvironmentVariable.siteUrl)}/api/cms/landing-page-slugs`
      ).then(({ slugs }) => {
        // CMS failures surface as an empty map; keep it only briefly so pods
        // recover fast without hammering the endpoint during an outage.
        if (cached === entry && (!slugs || Object.keys(slugs).length === 0)) {
          entry.expiresAt = Date.now() + EMPTY_SLUGS_TTL_MS;
        }
        return slugs;
      }),
      expiresAt: Date.now() + SLUGS_TTL_MS,
    };
    entry.promise.catch(() => {
      if (cached === entry) {
        cached = null;
      }
    });
    cached = entry;
  }

  return cached.promise;
}
